import simpleRestProvider from './ra-strapi-rest';

export default simpleRestProvider;
